import { Controller, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { Button, InputAdornment, Stack, TextField } from '@mui/material';
import { NumberInput } from '@qb/frontend/components/NumberInput/NumberInput';
const customPartSchema = z.object({
  partNumber: z.string().min(1, 'Please enter a part number'),
  manufacturer: z.string().optional(),
  description: z.string().min(1, 'Please add a description'),
  qty: z.number().int().min(1, 'Please enter at least 1 item'),
  price: z.string().regex(/^\d*\.?\d*$/, {
    message: 'Invalid price format'
  }).optional()
});
export type CustomPartFormData = z.infer<typeof customPartSchema>;
type CustomPartFormProps = {
  onSubmit: (data: CustomPartFormData) => void;
  isLoading?: boolean;
};
export const CustomPartForm = ({
  onSubmit,
  isLoading
}: CustomPartFormProps) => {
  const {
    register,
    control,
    handleSubmit,
    formState: {
      errors
    }
  } = useForm<CustomPartFormData>({
    resolver: zodResolver(customPartSchema),
    defaultValues: {
      qty: 1,
      price: ''
    }
  });
  return <form onSubmit={handleSubmit(onSubmit)} data-sentry-component="CustomPartForm" data-sentry-source-file="CustomPartForm.tsx">
      <Stack spacing={2} data-sentry-element="Stack" data-sentry-source-file="CustomPartForm.tsx">
        <Stack direction="row" spacing={4} sx={{
        alignItems: 'center'
      }} data-sentry-element="Stack" data-sentry-source-file="CustomPartForm.tsx">
          <Controller name="qty" control={control} render={({
          field: {
            onChange,
            value,
            ref
          }
        }) => <NumberInput ref={ref} initialValue={value} onValueChange={onChange} minValue={1} maxValue={9999} />} data-sentry-element="Controller" data-sentry-source-file="CustomPartForm.tsx" />
          <Button loading={isLoading} variant="contained" color="secondary" type="submit" fullWidth data-sentry-element="Button" data-sentry-source-file="CustomPartForm.tsx">
            Add to quote
          </Button>
        </Stack>
        <TextField fullWidth placeholder="Product Name / Part Number" {...register('partNumber')} error={!!errors.partNumber} helperText={errors.partNumber?.message} slotProps={{
        htmlInput: {
          maxLength: 255
        }
      }} data-sentry-element="TextField" data-sentry-source-file="CustomPartForm.tsx" />
        <TextField fullWidth placeholder="Manufacturer (Optional)" {...register('manufacturer')} slotProps={{
        htmlInput: {
          maxLength: 255
        }
      }} data-sentry-element="TextField" data-sentry-source-file="CustomPartForm.tsx" />
        <Controller name="price" control={control} render={({
        field,
        fieldState
      }) => <TextField {...field} fullWidth variant="outlined" placeholder="Price (Optional)" slotProps={{
        htmlInput: {
          inputMode: 'decimal'
        },
        input: {
          startAdornment: <InputAdornment position="start">$</InputAdornment>
        }
      }} error={!!fieldState.error} helperText={fieldState.error?.message} />} data-sentry-element="Controller" data-sentry-source-file="CustomPartForm.tsx" />
        <TextField fullWidth placeholder="Description" multiline rows={5} {...register('description')} error={!!errors.description} helperText={errors.description?.message} slotProps={{
        htmlInput: {
          maxLength: 300
        }
      }} data-sentry-element="TextField" data-sentry-source-file="CustomPartForm.tsx" />
      </Stack>
    </form>;
};